interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

const range = (start: number, end: number) => Array.from({ length: end - start + 1 }, (_, i) => start + i);

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  let pages: number[] = [];
  if (totalPages <= 7) {
    pages = range(1, totalPages);
  } else if (page <= 4) {
    pages = range(1, 6).concat([totalPages]);
  } else if (page >= totalPages - 3) {
    pages = [1].concat(range(totalPages - 5, totalPages));
  } else {
    pages = [1, page - 1, page, page + 1, totalPages];
  }

  return (
    <nav className="mt-8 md:mt-10 flex items-center justify-center gap-1.5 md:gap-2" aria-label="分页">
      <button
        type="button"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
        className="w-9 h-9 md:w-10 md:h-10 rounded-md border border-background-300 text-foreground-700 flex items-center justify-center disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-400 hover:text-primary-600 transition-colors duration-200 cursor-pointer"
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line text-lg" />
      </button>
      {pages.map((p, idx) => {
        const prev = pages[idx - 1];
        const gap = prev !== undefined && p - prev > 1;
        return (
          <span key={p} className="flex items-center gap-1.5 md:gap-2">
            {gap && <span className="text-foreground-400 text-sm px-1">…</span>}
            <button
              type="button"
              onClick={() => onChange(p)}
              className={`w-9 h-9 md:w-10 md:h-10 rounded-md text-sm font-label transition-colors duration-200 cursor-pointer ${
                p === page
                  ? "bg-primary-500 text-background-50"
                  : "border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
              }`}
              aria-current={p === page ? "page" : undefined}
            >
              {p}
            </button>
          </span>
        );
      })}
      <button
        type="button"
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
        className="w-9 h-9 md:w-10 md:h-10 rounded-md border border-background-300 text-foreground-700 flex items-center justify-center disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-400 hover:text-primary-600 transition-colors duration-200 cursor-pointer"
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line text-lg" />
      </button>
    </nav>
  );
}